import { instance } from "@/apis";
import { useQuery } from "@tanstack/react-query";

export const useChatSharedQuery = ({ shareId }: { shareId: string }) => {
  return useQuery({
    queryKey: ["chatShared", shareId],
    queryFn: async () => {
      return instance
        .get(`/api/df/user/chat/shared/${shareId}`)
        .then((res) => res.data.data);
    },
    enabled: !!shareId,
  });
};
